import React from 'react'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'
import Enrollaction from '../Components/Enrollaction/Enrollaction'
import Partnersec from '../Components/Partnersec/Partnersec'
import bnr1 from '../assets/others/11102071.jpg'
import bnr2 from '../assets/others/11102072.jpg'
import bnr3 from '../assets/others/11102073.jpg'
import cimg from '../assets/others/11102075.png'
import img1 from '../assets/others/11102074.png'
import cerimg from '../assets/others/sample-webinar-certificate.jpg'
import Featuredbox from '../Components/Featuredbox/Featuredbox'
import Corefeature from '../Components/Corefeature/Corefeature'
import Clientsay from '../Components/Clientsay/Clientsay'
import Programoffer from '../Components/Programoffer/Programoffer'
import Eventsec from '../Components/Eventsec/Eventsec'
import Acadereview from '../Components/Acadreview/Acadereview'
import { Helmet } from 'react-helmet-async'


const Academic = () => {
  return (
    <div>
        <Helmet>
             <title>Academic | Takshila VLSI</title>
            <meta name="description" content="Get job-oriented VLSI training in Bangalore and Hyderabad with expert-led courses, practical projects, industry skills, and placement support from Takshila VLSI." />
            <link rel="canonical" href="https://www.takshila-vlsi.com/academic/" />

            <meta property="og:locale" content="en_IN" />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Takshila VLSI" />
            <meta property="og:title" content="Academic | Takshila VLSI" />
            <meta property="og:description" content="Get job-oriented VLSI training in Bangalore and Hyderabad with expert-led courses, practical projects, industry skills, and placement support from Takshila VLSI." />
            <meta property="og:url" content="https://www.takshila-vlsi.com/academic/" />
            <meta property="og:image" content="https://www.takshila-vlsi.com/og-image.jpg" />
            <meta property="og:image:alt" content="Takshila VLSI training programs" />
        </Helmet>
        <Header/> 
        <main>
        <section className='section-banner pg-banner bg-img dark-bg'>
            <div class="container text-center">
                          <div class="row justify-content-around ">
                              <div class="col-lg-10 p-lg-5 p-3 pt-4">
                                <div class="pg-title-sec">
                                    <h1 className='pg-title pb-3'>Support your students in reaching professional goals
                                    </h1>
                                    <p class="pg-title-desc"> Prepare your students for career success by providing them with hands-on VLSI & Embedded Systems projects, a modern curriculum, and diverse career opportunities in the VLSI & Embedded Systems sector.</p>
                                 </div>
                              </div>
                            </div>
                            <div class="row justify-content-center img-radius">
                                <div class="col-md-4 align-self-end d-none d-sm-block">
                                <img src={bnr1} alt=''/>
                                </div>
                                <div class="col-md-4 align-self-end">
                                <img src={bnr2} alt=''/>
                                </div>
                                <div class="col-md-4 align-self-end d-none d-sm-block">
                                <img src={bnr3} alt=''/>
                                </div>
                            </div>

            </div>
          </section>
          <Featuredbox/>
          <section className='ws-section pb-5 bg-13 mt-5'>
            <div class="container">
                    <div class="row">
                        <div class="col-lg text-center">
                        <h2 className='ws-section_heading pd-03'>Benifits of Takshila MOU</h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6">
                        <img src={img1} alt=''/>
                        </div>
                        <div class="col-lg-6">
                        <div class="row">
                            <div class="col-lg-12">
                                <div className='step-card bg-linear radius-1 mb-4 d-flex p-3 dark-bg'>
                                    <div className='step'>01</div>
                                    <div className='step-content'>
                                        <h5 className='step-card-head mb-2'>Internship and job opportunities</h5>
                                        <p>The MOU can provide students with hands-on experience and networking opportunities through internship at our organisations.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div className='step-card bg-linear radius-1 mb-4 d-flex p-3 dark-bg'>
                                    <div className='step'>02</div>
                                    <div className='step-content'>
                                        <h5 className='step-card-head mb-2'>Collaborative research opportunities</h5>
                                        <p>The MOU can establish a framework for the college and the organisation to work together on research project which can lead to new discoveries and advancement in various fields.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div className='step-card bg-linear radius-1 mb-4 d-flex p-3 dark-bg'>
                                    <div className='step'>03</div>
                                    <div className='step-content'>
                                        <h5 className='step-card-head mb-2'>Access to resources</h5>
                                        <p>The MOU can give the college access to resource and expertise at the organisation such as equipment facilities our specialised knowledge. </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div className='step-card bg-linear radius-1 mb-4 d-flex p-3 dark-bg'>
                                    <div className='step'>04</div>
                                    <div className='step-content'>
                                        <h5 className='step-card-head mb-2'>Community engagement</h5>
                                        <p>The MOU can all be used as a platform for both parties lot engage with the community and make a positive impact on society.</p>
                                    </div>
                                </div>
                            </div>
                            
                            
                        </div>
                        </div>
                        
                    </div>
                    </div>
            </section>
            <section className='ws-section winning-sec pb-5'>
            <div class="container">
                    <div class="row">
                        <div class="col-lg text-center">
                        <h2 className='ws-section_heading pd-03'>Events/Webinar</h2>
                        </div>
                    </div>
                    <Eventsec/> 
             </div>
          </section>
          <section className='course-section dark-background-2'>
             <Programoffer/>
            </section>
          <Corefeature/>
            <section className='ws-section clientsay-section bg-5 dark-bg pb-5'>
                <div class="container">
                        <div class="row">
                            <div class="col-lg text-center">
                            <h2 className='ws-section_heading pd-03'>What Our Clinet Says</h2>
                            </div>
                        </div>
                        <Clientsay/> 
                </div>
            </section>
          <section className='companysec bg-13 '>
           <div class="container text-center p-5">
                         <div class="row justify-content-around text-center">
                              <div class="col-md p-3">
                                    <h2 className='ws-section_heading pd-03'><span className='font-thi'>Tie-up with 2000+ college/universities</span></h2>
                              </div>
                          </div>
                          <div class="row justify-content-around">
                              <div class="col-md-11">
                              <img src={cimg} alt=''/>
                              </div>
                          </div>
                </div>
        </section>
        <section className='ws-section clientsay-section p-lg-5'>
                <div class="container">
                        <div class="row">
                            <div class="col-lg text-center">
                            <h2 className='ws-section_heading pd-03'>Academic Testimonials
                            </h2>
                            </div>
                        </div>
                        <Acadereview/> 
                </div>
            </section>
        </main> 
        <Enrollaction/>
         <section className='video-section p-lg-5 pt-4'>
          <div class="container text-center">
              <div className='row'>
                  <div className='col-lg text-center pb-3'>
                  <h2 class="ws-section_heading">Our Webinars
                  </h2>
              </div>
              </div>
              <div class="row justify-content-center">
                  <div class="col-lg-3">
                      <iframe
                          width="100%"
                          height="250"
                          src={`https://www.youtube.com/embed/COw-qJtt6gI`}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                          title="Embedded youtube"
                          poster="hqdefault"
                      />
                  </div>
                  <div class="col-lg-3">
                  <iframe
                      width="100%"
                      height="250"
                      src={`https://www.youtube.com/embed/p1cNheyIMSk`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      title="Embedded youtube"
                      poster="hqdefault"
                  />
                  </div>
                  <div class="col-lg-3">
                  <iframe
                      width="100%"
                      height="250"
                      src={`https://www.youtube.com/embed/_CxigMMw6XQ`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      title="Embedded youtube"
                      poster="hqdefault"
                  />
                  </div>
                  <div class="col-lg-3">
                  <iframe
                      width="100%"
                      height="250"
                      src={`https://www.youtube.com/embed/okD96I7HmlE`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      title="Embedded youtube"
                      poster="hqdefault"
                  />
                  </div>
              </div>
          </div>
      </section>
      <section className='mt-3 pb-5'>
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-9">
                 <h2 className='ws-section_heading pd-03'>Sample Webinar Certificate</h2>
                </div>
            </div>
            <div class="row justify-content-center">
            <div class="col-lg-9">
                <img src={cerimg} alt=''/>
            </div>
            </div>
        </div>
      </section>

        <Partnersec/> 
        <Footer/> 
    </div>
  )
}

export default Academic